<template>
	<div class="chat-game-role">
		<div class="chat-game-role-search">
			<input type="datetime-local" v-model="requestParam.start_time">
			<input type="datetime-local" v-model="requestParam.end_time">
			<input type="text" class="chat-game-role-input" v-model="requestParam.keywords" placeholder="订单号">
			<input type="text" class="chat-game-role-input" v-model="requestParam.u_id" placeholder="用户ID">
			<input type="text" class="chat-game-role-input" v-model="requestParam.role_name" placeholder="角色名">
			<span @click="search">搜索</span>
		</div>
		<div class="chat-game-role-box">
			<div class="chat-game-role-wrap">
				<table class="layui-table">
				  <thead>
				    <tr>
						<th>平台</th>
						<th>用户ID</th>
						<th>游戏/区名</th>
						<th>角色名</th>
						<th>订单号</th>
						<!-- <th>渠道名</th> -->
						<th>金额</th>
						<th>渠道</th>
						<th>充值时间</th>
				    </tr> 
				  </thead>
				  <tbody v-if="userList.length > 0">
				    <tr v-for="(user,index) in userList">
				      <td>{{user.platform}}</td>
					  <td>{{user.u_id}}</td>
					  <td>{{user.game_name}}/{{user.area_name}}</td>
					  <td>{{user.role_name}}</td>
					  <td>{{user.order_number}}</td>
					  <!-- <td>{{user.channel_name}}</td> -->
					  <td>{{user.recharge_amount}}</td>
					  <td>{{user.recharge_channel}}</td>
					  <td>{{user.recharge_time}}</td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="10" style="text-align: center;">{{errorMsg}}</td>
					  </tr>
				  </tbody>
				</table>
			</div>
		</div>
		<div class="chat-game-role-page">
			<page-component
				:dataApi="dataApi" 
				:requestParams="requestParam" 
				@page-call="pageCall($event)" 
				key="chat-game-role-page"
				ref="ChatChatOrderPage">
			</page-component>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../../components/PageComponent.vue'
	import {getOrderList} from '../../../network/game/game.js'
	
	export default{
		name:"ChatGameOrder",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			PageComponent
		},
		data(){
			return {
				userList: [],
				dataApi: getOrderList,
				requestParam:{
					start_time:'',
					end_time:'',
					prePage: 10,
					fans_id:0,
					keywords: '',
					u_id: '',
					role_name: ''
				},
				errorMsg: '数据请求中...'
			}
		},
		methods:{
			// 分页数据回调
			pageCall(data){
				this.userList = data
				if(data.length === 0){
					this.errorMsg = '暂无订单数据'
				}else{
					// 统计金额
					let recharge_total = 0
					for (var i = 0; i < this.userList.length; i++) {
						let temp = this.userList[i]
						recharge_total += parseFloat(temp['recharge_amount'])
					}
					this.userList.push({
						platform: '总计',
						recharge_amount: recharge_total
					})
				}
			},
			
			// 搜索
			search(){
				this.$refs.ChatChatOrderPage.initPage()
			}
		},
		created() {
			this.requestParam.fans_id = this.chatUser.fans_id
		}
	}
</script>

<style>
.chat-game-role{
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #FFFFFF;
		z-index: 12;
	}
	.chat-game-role-search{
		height: 28px;
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-game-role-search input{
		height: 26px;
		line-height: 26px;
		width: 166px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
		margin-right: 3px;
	}
	.chat-game-role-search span{
		display: inline-block;
		line-height: 28px;
		padding: 0 10px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
		user-select: none;
	}
	.chat-game-role-search .chat-game-role-input{
		width: 100px !important;
	}
	.chat-game-role-back{
		background-color: #00aaff !important;
	}
	.chat-game-role-box{
		position: absolute;
		top: 48px;
		left: 0;
		right: 0;
		bottom: 60px;
		overflow: hidden;
	}
	.chat-game-role-box .chat-game-role-wrap{
		position: relative;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-game-role-wrap>table{
		margin: 0;
		word-break: break-all;
	}
	.chat-game-role-wrap button{
		padding: 0 10px;
		font-size: 12px;
		line-height: 22px;
		background-color: #378996;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
	}
	.chat-game-role-wrap span{
		font-size: 12px;
	}
	.chat-game-role-page{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 26px;
		padding: 17px 0;
	}
</style>
